<template>
  <div style="display: flex; height: 100%; margin-top: -20px">
    <div class="dy">
      <p class="p-bar">
        <span>温度场分析</span>
        <span :class="errorFlag ? 'status2' : 'status'">
          【{{ errorFlag ? "异常" : "正常" }}】
        </span>
      </p>
      <p class="p-bar">
        <span>变压器模型对比</span>
        <span :class="errorFlag ? 'status2' : 'status'">
          【{{ errorFlag ? "异常" : "正常" }}】
        </span>
      </p>
      <p class="p-bar">
        <span>变压器寿命评估:</span>
        <span :class="errorFlag ? 'status2' : 'status'"> 【>10年】 </span>
      </p>
      <p class="p-bar">
        <span>未来24时热点温度预警</span>
      </p>
      <p class="p-bar">
        <span class="status1">重点数据：01</span>
        <span class="status2">异常数据：{{ errorFlag ? "温度" : "无" }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorFlag: false,
    };
  },
};
</script>

<style scoped>
p.p-bar {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: larger;
}
</style>
